var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents4" }, [
    _c("img", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.isMobile,
          expression: "!isMobile"
        }
      ],
      staticClass: "bg",
      attrs: { src: "static/img/service/bg_white.png" }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isMobile,
            expression: "!isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("div", { staticClass: "wrap" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/contact?tab=corporate-vehicle"
                      )
                    }
                  }
                },
                [_c("img", { attrs: { src: "static/img/service/btn.png" } })]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isMobile,
            expression: "isMobile"
          }
        ],
        staticClass: "contents"
      },
      [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "text" }, [
          _c("img", {
            attrs: { src: "static/img/mobile/service/background_white_04.png" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "wrap" }, [
            _vm._m(5),
            _vm._v(" "),
            _vm._m(6),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.gotoPage(
                        "https://www.carsuri.co.kr/contact?tab=corporate-vehicle"
                      )
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: "static/img/mobile/service/btn.png" }
                  })
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: "static/img/service/site_service_img_04.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", { attrs: { src: "static/img/icon_computer.png" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("B2B "),
      _c("span", [_vm._v("관제 서비스")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [
        _vm._v(
          "\n            효율적인 차량 운영 관리를 위한 스마트 관제 시스템 제공\n          "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            · 스마트 관제 시스템을 통한 실시간 모니터링 가능"
        ),
        _c("br"),
        _vm._v("\n            · 전국 순회 정비망 구축"),
        _c("br"),
        _vm._v(
          "\n            · B2B 파트너사 보유 차량 누적 100만대 관리 중\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: { src: "static/img/mobile/service/site_service_img_04_m.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon" }, [
      _c("img", {
        attrs: { src: "static/img/mobile/service/icon_computer.png" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _vm._v("B2B "),
      _c("span", [_vm._v("관제 서비스")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "body" }, [
      _c("p", [
        _vm._v("효율적인 차량 운영 관리를 위한 "),
        _c("br"),
        _vm._v("스마트 관제 시스템 제공")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            · 스마트 관제 시스템을 통한"),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticStyle: { "margin-left": "3%" } }, [
          _vm._v("실시간 모니터링 가능")
        ]),
        _c("br"),
        _vm._v("\n            · 전국 순회 정비망 구축"),
        _c("br"),
        _vm._v("\n            · B2B 파트너사 보유 차량"),
        _c("br"),
        _vm._v(" "),
        _c("span", { staticStyle: { "margin-left": "3%" } }, [
          _vm._v(" 누적 100만대 관리 중")
        ]),
        _c("br")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-362d323b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-362d323b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/service/Contents4.vue
// module id = null
// module chunks = 